/* eslint-disable max-len */
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

export default class StatMessages {
  constructor(intl) {
    this.messageDefinitions = defineMessages({
      ABANDONED_CALLS: {
        id: 'ABANDONED_CALLS',
        defaultMessage: 'Abandoned Calls',
      },
      ABANDONED_CALLS_DESC: {
        id: 'ABANDONED_CALLS_DESC',
        defaultMessage: 'Number of calls that abandoned the queue before being offered to an agent.',
      },

      ADJUSTED_ABANDONED_CALLS: {
        id: 'ADJUSTED_ABANDONED_CALLS',
        defaultMessage: 'Adjusted Abandoned Calls',
      },
      ADJUSTED_ABANDONED_CALLS_DESC: {
        id: 'ADJUSTED_ABANDONED_CALLS_DESC',
        defaultMessage: 'Number of calls that abandoned the queue in under 10 seconds.',
      },

      ADJUSTED_CALLS_OFFERED: {
        id: 'ADJUSTED_CALLS_OFFERED',
        defaultMessage: 'Adjusted Calls Offered',
      },
      ADJUSTED_CALLS_OFFERED_DESC: {
        id: 'ADJUSTED_CALLS_OFFERED_DESC',
        defaultMessage: 'Adjusted number of calls that reached the queue. Excludes calls abandoned in less than 10 seconds.',
      },

      ADJUSTED_ABANDON_RATE: {
        id: 'ADJUSTED_ABANDON_RATE',
        defaultMessage: 'Adjusted Abandon Rate',
      },
      ADJUSTED_ABANDON_RATE_DESC: {
        id: 'ADJUSTED_ABANDON_RATE_DESC',
        defaultMessage: 'Percentage of calls offered that were abandoned in under 10 seconds. (Adj Abandoned Calls) / (Calls Offered)',
      },

      AGENT: {
        id: 'AGENT',
        defaultMessage: 'Agent Name',
      },
      AGENTS_AVAILABLE: {
        id: 'AGENTS_AVAILABLE',
        defaultMessage: 'Agents Available',
      },
      AGENTS_IDLE: {
        id: 'AGENTS_IDLE',
        defaultMessage: 'Agents Idle',
      },
      AGENTS_LOGGED_IN: {
        id: 'AGENTS_LOGGED_IN',
        defaultMessage: 'Agents Logged In',
      },
      AGENTS_ONLINE: {
        id: 'AGENTS_ONLINE',
        defaultMessage: 'Agents Online',
      },
      AGENT_PRESENCE: {
        id: 'AGENT_PRESENCE',
        defaultMessage: 'Agent Presence',
      },
      AGENT_STATUS: {
        id: 'AGENT_STATUS',
        defaultMessage: 'Agent Status',
      },

      // AVERAGE_ANSWER_SPEED: {
      //   id: 'AVERAGE_ANSWER_SPEED',
      //   defaultMessage: 'Average Answer Speed',
      // },
      AVERAGE_ANSWER_SPEED_DESC: {
        id: 'AVERAGE_ANSWER_SPEED_DESC',
        defaultMessage: 'Average time a call is in the queue before being dispatched to an agent.',
      },

      ABANDON_RATE: {
        id: 'ABANDON_RATE',
        defaultMessage: 'Abandon Rate',
      },
      ABANDON_RATE_DESC: {
        id: 'ABANDON_RATE_DESC',
        defaultMessage: 'Percentage of calls offered that were abandoned. (Abandoned Calls) / (Calls Offered)',
      },

      ACTIVE_CALLS: {
        id: 'ACTIVE_CALLS',
        defaultMessage: 'Active Calls',
      },

      AVERAGE_HANDLE_TIME: {
        id: 'AVERAGE_HANDLE_TIME',
        defaultMessage: 'Average Handle Time',
      },
      AVERAGE_HANDLE_TIME_DESC: {
        id: 'AVERAGE_HANDLE_TIME_DESC',
        defaultMessage: 'Average time an agent spent on a call. Includes Talk Time (TT), Hold Time (AH), and Disposition Time (ACW)',
      },

      AVERAGE_HOLD_TIME: {
        id: 'AVERAGE_HOLD_TIME',
        defaultMessage: 'Average Hold Time',
      },
      AVERAGE_HOLD_TIME_DESC: {
        id: 'AVERAGE_HOLD_TIME_DESC',
        defaultMessage: 'Average number of seconds a caller spends on hold with an agent in the selected queue. If none selected, total for all queues will be displayed. Excludes waiting time in Call Queue.',
      },

      AVERAGE_TALK_TIME: {
        id: 'AVERAGE_TALK_TIME',
        defaultMessage: 'Average Talk Time',
      },
      AVERAGE_TALK_TIME_DESC: {
        id: 'AVERAGE_TALK_TIME_DESC',
        defaultMessage: 'Average number of seconds spent by agent talking per answered call on calls originating through a Call Queue.',
      },
      ASSISTED_CALLS: {
        id: 'ASSISTED_CALLS',
        defaultMessage: 'Assisted Calls',
      },
      ASSISTED_CALLS_DESC: {
        id: 'ASSISTED_CALLS_DESC',
        defaultMessage: 'Number of calls answered and passed onto a different agent for further handling.',
      },

      AVERAGE_WAIT_TIME: {
        id: 'AVERAGE_WAIT_TIME',
        defaultMessage: 'Average Wait Time',
      },
      AVERAGE_WAIT_TIME_DESC: {
        id: 'AVERAGE_WAIT_TIME_DESC',
        defaultMessage: 'Average number of seconds a caller spent in the selected queue before being dispatched to an agent. If none selected, total for all queues will be displayed.',
      },

      CALLER_NAME: {
        id: 'CALLER_NAME',
        defaultMessage: 'Caller Name',
      },
      CALLER_NUMBER: {
        id: 'CALLER_NUMBER',
        defaultMessage: 'Caller Number',
      },
      CALLER_STATUS: {
        id: 'CALLER_STATUS',
        defaultMessage: 'Status',
      },
      CALLER_WAIT_TIME: {
        id: 'CALLER_WAIT_TIME',
        defaultMessage: 'Wait Time',
      },

      CALLS_FORWARDED: {
        id: 'CALLS_FORWARDED',
        defaultMessage: 'Calls Forwarded',
      },
      CALLS_FORWARDED_DESC: {
        id: 'CALLS_FORWARDED_DESC',
        defaultMessage: 'Number of calls forwarded to another queue or offnet phone number for handling. Includes forwarded calls to voicemail.',
      },

      CALLS_HANDLED: {
        id: 'CALLS_HANDLED',
        defaultMessage: 'Calls Handled',
      },
      CALLS_HANDLED_DESC: {
        id: 'CALLS_HANDLED_DESC',
        defaultMessage: 'Number of calls answered by agent originating through a Call Queue.',
      },

      CALLS_OFFERED: {
        id: 'CALLS_OFFERED',
        defaultMessage: 'Calls Offered',
      },
      CALLS_OFFERED_DESC: {
        id: 'CALLS_OFFERED_DESC',
        defaultMessage: 'Number of calls that reached the queue to be dispatched to agents. Includes abandoned calls. Excludes forwards and voicemail.',
      },

      CALLS_TO_VOICEMAIL: {
        id: 'CALLS_TO_VOICEMAIL',
        defaultMessage: 'Calls to Voicemail',
      },
      CALLS_TO_VOICEMAIL_DESC: {
        id: 'CALLS_TO_VOICEMAIL_DESC',
        defaultMessage: 'Number of calls handled by the automated voicemail system.',
      },

      CALLS_WAITING: {
        id: 'CALLS_WAITING',
        defaultMessage: 'Calls Waiting',
      },
      CALLS_WAITING_DESC: {
        id: 'CALLS_WAITING_DESC',
        defaultMessage: 'Active number of callers waiting in the selected queue. If none selected, total for all queues will be displayed.',
      },

      CALLBACKS: {
        id: 'CALLBACKS',
        defaultMessage: 'Callbacks',
      },
      CALLBACKS_DESC: {
        id: 'CALLBACKS_DESC',
        defaultMessage: 'Number of calls where the the caller requested a callback instead waiting in the queue.',
      },

      CALL_VOLUME: {
        id: 'CALL_VOLUME',
        defaultMessage: 'Call Volume',
      },
      CALL_VOLUME_DESC: {
        id: 'CALL_VOLUME_DESC',
        defaultMessage: 'Number of calls originating through the selected queue. If none selected, total for all queues will be displayed. Includes answered calls, abandonded calls, forwards, and voicemail.',
      },

      INBOUND_ATTEMPTS: {
        id: 'INBOUND_ATTEMPTS',
        defaultMessage: 'Inbound Attempts',
      },
      INBOUND_ATTEMPTS_DESC: {
        id: 'INBOUND_ATTEMPTS_DESC',
        defaultMessage: 'Number of attempted calls inbound to agent. Includes call center calls. Excludes on-net calls and conference calls.',
      },

      INBOUND_ANSWERED: {
        id: 'INBOUND_ANSWERED',
        defaultMessage: 'Inbound Answered',
      },
      INBOUND_ANSWERED_DESC: {
        id: 'INBOUND_ANSWERED_DESC',
        defaultMessage: 'Number of inbound answered calls to an agent. Includes call center calls. Excludes on-net calls and conference calls.',
      },

      INBOUND_MINUTES: {
        id: 'INBOUND_MINUTES',
        defaultMessage: 'Inbound Minutes',
      },
      INBOUND_MINUTES_DESC: {
        id: 'INBOUND_MINUTES_DESC',
        defaultMessage: 'Number of minutes spent by an agent on inbound calls. Includes call center calls. Includes talk and hold time. Excludes on-net calls and conference calls.',
      },

      INBOUND_AVERAGE: {
        id: 'INBOUND_AVERAGE',
        defaultMessage: 'Inbound Average',
      },
      INBOUND_AVERAGE_DESC: {
        id: 'INBOUND_AVERAGE_DESC',
        defaultMessage: 'Average length of time spent by an agent on inbound calls. Includes call center calls. Excludes on-net calls and conference calls.',
      },

      LONGEST_WAIT: {
        id: 'LONGEST_WAIT',
        defaultMessage: 'Longest Wait',
      },

      MISSED_CALLS: {
        id: 'MISSED_CALLS',
        defaultMessage: 'Missed Calls',
      },
      MISSED_CALLS_DESC: {
        id: 'MISSED_CALLS_DESC',
        defaultMessage: 'Number of calls originating through a Call Queue offered to an agent but not answered.',
      },

      OUTBOUND_ANSWERED: {
        id: 'OUTBOUND_ANSWERED',
        defaultMessage: 'Outbound Answered',
      },
      OUTBOUND_ANSWERED_DESC: {
        id: 'OUTBOUND_ANSWERED_DESC',
        defaultMessage: 'Number of outbound calls by agent answered by remote party. Includes calls answered by voicemail. Excludes on-net calls and conference calls.',
      },

      OUTBOUND_TALK_TIME: {
        id: 'OUTBOUND_TALK_TIME',
        defaultMessage: 'Outbound Talk Time',
      },
      OUTBOUND_TALK_TIME_DESC: {
        id: 'OUTBOUND_TALK_TIME_DESC',
        defaultMessage: 'The total length of time spent by agent on outbound calls. Excludes call center calls, on-net calls, and conference calls.',
      },

      OUTBOUND_AVERAGE: {
        id: 'OUTBOUND_AVERAGE',
        defaultMessage: 'Outbound Average',
      },
      OUTBOUND_AVERAGE_DESC: {
        id: 'OUTBOUND_AVERAGE_DESC',
        defaultMessage: 'Average length of time spent by agent on outbound calls. Excludes call center calls, on-net calls, and conference calls.',
      },

      OUTBOUND_ATTEMPTS: {
        id: 'OUTBOUND_ATTEMPTS',
        defaultMessage: 'Outbound Attempts',
      },
      OUTBOUND_ATTEMPTS_DESC: {
        id: 'OUTBOUND_ATTEMPTS_DESC',
        defaultMessage: 'Number of outbound call attempts by agent. Excludes on-net calls and conference calls.',
      },

      PERCENT_DIAL_TRANSFERS: {
        id: 'PERCENT_DIAL_TRANSFERS',
        defaultMessage: 'Percent Dial Transfers',
      },
      PERCENT_DIAL_TRANSFERS_DESC: {
        id: 'PERCENT_DIAL_TRANSFERS_DESC',
        defaultMessage: 'Percentage of calls that landed in the queue and were offered to an agent.',
      },

      PEAK_ACTIVE_CALLS: {
        id: 'PEAK_ACTIVE_CALLS',
        defaultMessage: 'Peak Active Calls',
      },

      QUEUE_EXTENSION: {
        id: 'QUEUE_EXTENSION',
        defaultMessage: 'Queue Extension',
      },
      QUEUE_NAME: {
        id: 'QUEUE_NAME',
        defaultMessage: 'Queue Name',
      },

      SERVICE_LEVEL: {
        id: 'SERVICE_LEVEL',
        defaultMessage: 'Service Level',
      },
      SERVICE_LEVEL_DESC: {
        id: 'SERVICE_LEVEL_DESC',
        defaultMessage: 'The ratio of calls meeting the configurable service level agreement.',
      },

      TOTAL_TALK_TIME: {
        id: 'TOTAL_TALK_TIME',
        defaultMessage: 'Total Talk Time',
      },
      TOTAL_TALK_TIME_DESC: {
        id: 'TOTAL_TALK_TIME_DESC',
        defaultMessage: 'Number of seconds spent by agent on answered calls originating through a Call Queue.',
      },

      SMS_SESSIONS: {
        id: 'SMS_SESSIONS',
        defaultMessage: 'SMS Sessions',
      },
      SMS_AVERAGE_HANDLE_TIME: {
        id: 'SMS_AVERAGE_HANDLE_TIME',
        defaultMessage: 'SMS Average Handle Time',
      },
    });

    /**
     * @type {{TT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, ATT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AgentPresence: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, AHT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CallerNumber: {unit: string, labelStr: *, label: JSX.Element}, SMS_AHT: {unit: string, labelStr: *, label: JSX.Element}, DT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, FWD: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AgentStatus: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, MC: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, IA: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, SL: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, Peak: {unit: string, labelStr: *, label: JSX.Element}, CallerName: {unit: string, labelStr: *, label: JSX.Element}, QueueExtension: {unit: string, labelStr: *, label: JSX.Element}, QueueName: {unit: string, labelStr: *, label: JSX.Element}, AWT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, OM: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CB: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, Agent: {unit: string, labelStr: *, label: JSX.Element}, AC: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AST: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AAC: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, ActiveCalls: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, LongestWait: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, IM: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AgentsOnline: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, CH: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, SMS_VOL: {unit: string, labelStr: *, label: JSX.Element}, AgentsLoggedIn: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, CallerWaitTime: {unit: string, labelStr: *, label: JSX.Element}, AH: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, OAvg: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, IAVG: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CO: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, ACO: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CallerStatus: {unit: string, labelStr: *, label: JSX.Element}, AgentsAvailable: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, AR: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CallsWaiting: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element, liveData: boolean}, AAR: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, VOL: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, OANS: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, CW: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, OATT: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, VM: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}, AgentsIdle: {unit: string, labelStr: *, label: JSX.Element, liveData: boolean}, IANS: {unit: string, description: JSX.Element, labelStr: *, label: JSX.Element}}}
     */
    this.messages = {
      AC: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.ABANDONED_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ABANDONED_CALLS }),
        description: <FormattedMessage {...this.messageDefinitions.ABANDONED_CALLS_DESC} />,
      },
      AAC: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.ADJUSTED_ABANDONED_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ADJUSTED_ABANDONED_CALLS }),
        description: <FormattedMessage {...this.messageDefinitions.ADJUSTED_ABANDONED_CALLS_DESC} />,
      },
      AAR: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.ADJUSTED_ABANDON_RATE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ADJUSTED_ABANDON_RATE }),
        description: <FormattedMessage {...this.messageDefinitions.ADJUSTED_ABANDON_RATE_DESC} />,
      },
      // AAS: {
      //   unit: 'minutes',
      //   label: <FormattedMessage {...this.messageDefinitions.AVERAGE_ANSWER_SPEED} />,
      //   labelStr: intl.formatMessage({ ...this.messageDefinitions.AVERAGE_ANSWER_SPEED }),
      //   description: <FormattedMessage {...this.messageDefinitions.AVERAGE_ANSWER_SPEED_DESC} />,
      // },
      ACO: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.ADJUSTED_CALLS_OFFERED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ADJUSTED_CALLS_OFFERED }),
        description: <FormattedMessage {...this.messageDefinitions.ADJUSTED_CALLS_OFFERED_DESC} />,
      },
      AR: {
        unit: 'percent',
        label: <FormattedMessage {...this.messageDefinitions.ABANDON_RATE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ABANDON_RATE }),
        description: <FormattedMessage {...this.messageDefinitions.ABANDON_RATE_DESC} />,
      },
      ActiveCalls: {
        unit: 'calls',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.ACTIVE_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ACTIVE_CALLS }),
      },
      Agent: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.AGENT} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENT }),
      },
      AgentPresence: {
        unit: 'string',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENT_PRESENCE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENT_PRESENCE }),
      },
      AgentStatus: {
        unit: 'string',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENT_STATUS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENT_STATUS }),
      },
      AgentsAvailable: {
        unit: 'agents',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENTS_AVAILABLE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENTS_AVAILABLE }),
      },
      AgentsIdle: {
        unit: 'agents',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENTS_IDLE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENTS_IDLE }),
      },
      AgentsLoggedIn: {
        unit: 'agents',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENTS_LOGGED_IN} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENTS_LOGGED_IN }),
      },
      AgentsOnline: {
        unit: 'agents',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.AGENTS_ONLINE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AGENTS_ONLINE }),
      },
      AH: {
        unit: 'seconds',
        label: <FormattedMessage {...this.messageDefinitions.AVERAGE_HOLD_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AVERAGE_HOLD_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.AVERAGE_HOLD_TIME_DESC} />,
      },
      AHT: {
        unit: 'seconds',
        label: <FormattedMessage {...this.messageDefinitions.AVERAGE_HANDLE_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AVERAGE_HANDLE_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.AVERAGE_HANDLE_TIME_DESC} />,
      },
      ATT: {
        unit: 'seconds',
        label: <FormattedMessage {...this.messageDefinitions.AVERAGE_TALK_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AVERAGE_TALK_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.AVERAGE_TALK_TIME_DESC} />,
      },
      AST: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.ASSISTED_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.ASSISTED_CALLS }),
        description: <FormattedMessage {...this.messageDefinitions.ASSISTED_CALLS_DESC} />,
      },
      AWT: {
        unit: 'seconds',
        label: <FormattedMessage {...this.messageDefinitions.AVERAGE_WAIT_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.AVERAGE_WAIT_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.AVERAGE_WAIT_TIME_DESC} />,
      },
      CallerName: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.CALLER_NAME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLER_NAME }),
      },
      CallerNumber: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.CALLER_NUMBER} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLER_NUMBER }),
      },
      CallerStatus: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.CALLER_STATUS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLER_STATUS }),
      },
      CallerWaitTime: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.CALLER_WAIT_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLER_WAIT_TIME }),
      },
      CallsWaiting: {
        unit: 'calls',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.CALLS_WAITING} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_WAITING }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_WAITING_DESC} />,
      },
      CB: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLBACKS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLBACKS }),
        description: <FormattedMessage {...this.messageDefinitions.CALLBACKS_DESC} />,
      },

      CW: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLS_WAITING} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_WAITING }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_WAITING_DESC} />,
      },
      CH: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLS_HANDLED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_HANDLED }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_HANDLED_DESC} />,
      },
      CO: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLS_OFFERED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_OFFERED }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_OFFERED_DESC} />,
      },
      DT: {
        unit: 'percent',
        label: <FormattedMessage {...this.messageDefinitions.PERCENT_DIAL_TRANSFERS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.PERCENT_DIAL_TRANSFERS }),
        description: <FormattedMessage {...this.messageDefinitions.PERCENT_DIAL_TRANSFERS_DESC} />,
      },
      FWD: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLS_FORWARDED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_FORWARDED }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_FORWARDED_DESC} />,
      },
      IA: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.INBOUND_ATTEMPTS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.INBOUND_ATTEMPTS }),
        description: <FormattedMessage {...this.messageDefinitions.INBOUND_ATTEMPTS_DESC} />,
      },
      IANS: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.INBOUND_ANSWERED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.INBOUND_ANSWERED }),
        description: <FormattedMessage {...this.messageDefinitions.INBOUND_ANSWERED_DESC} />,
      },
      IM: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.INBOUND_MINUTES} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.INBOUND_MINUTES }),
        description: <FormattedMessage {...this.messageDefinitions.INBOUND_MINUTES_DESC} />,
      },
      IAVG: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.INBOUND_AVERAGE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.INBOUND_AVERAGE }),
        description: <FormattedMessage {...this.messageDefinitions.INBOUND_AVERAGE_DESC} />,
      },
      LongestWait: {
        unit: 'minutes',
        liveData: true,
        label: <FormattedMessage {...this.messageDefinitions.LONGEST_WAIT} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.LONGEST_WAIT }),
      },
      MC: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.MISSED_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.MISSED_CALLS }),
        description: <FormattedMessage {...this.messageDefinitions.MISSED_CALLS_DESC} />,
      },
      OATT: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.OUTBOUND_ATTEMPTS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.OUTBOUND_ATTEMPTS }),
        description: <FormattedMessage {...this.messageDefinitions.OUTBOUND_ATTEMPTS_DESC} />,
      },
      OANS: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.OUTBOUND_ANSWERED} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.OUTBOUND_ANSWERED }),
        description: <FormattedMessage {...this.messageDefinitions.OUTBOUND_ANSWERED_DESC} />,
      },
      OM: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.OUTBOUND_TALK_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.OUTBOUND_TALK_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.OUTBOUND_TALK_TIME_DESC} />,
      },
      OAvg: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.OUTBOUND_AVERAGE} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.OUTBOUND_AVERAGE }),
        description: <FormattedMessage {...this.messageDefinitions.OUTBOUND_AVERAGE_DESC} />,
      },
      Peak: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.PEAK_ACTIVE_CALLS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.PEAK_ACTIVE_CALLS }),
      },
      QueueExtension: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.QUEUE_EXTENSION} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.QUEUE_EXTENSION }),
      },
      QueueName: {
        unit: 'string',
        label: <FormattedMessage {...this.messageDefinitions.QUEUE_NAME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.QUEUE_NAME }),
      },
      SL: {
        unit: 'percent',
        label: <FormattedMessage {...this.messageDefinitions.SERVICE_LEVEL} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.SERVICE_LEVEL }),
        description: <FormattedMessage {...this.messageDefinitions.SERVICE_LEVEL_DESC} />,
      },
      SMS_VOL: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.SMS_SESSIONS} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.SMS_SESSIONS }),
      },
      SMS_AHT: {
        unit: 'minutes',
        label: <FormattedMessage {...this.messageDefinitions.SMS_AVERAGE_HANDLE_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.SMS_AVERAGE_HANDLE_TIME }),
      },
      TT: {
        unit: 'seconds',
        label: <FormattedMessage {...this.messageDefinitions.TOTAL_TALK_TIME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.TOTAL_TALK_TIME }),
        description: <FormattedMessage {...this.messageDefinitions.TOTAL_TALK_TIME_DESC} />,
      },
      VM: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALLS_TO_VOICEMAIL} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALLS_TO_VOICEMAIL }),
        description: <FormattedMessage {...this.messageDefinitions.CALLS_TO_VOICEMAIL_DESC} />,
      },
      VOL: {
        unit: 'calls',
        label: <FormattedMessage {...this.messageDefinitions.CALL_VOLUME} />,
        labelStr: intl.formatMessage({ ...this.messageDefinitions.CALL_VOLUME }),
        description: <FormattedMessage {...this.messageDefinitions.CALL_VOLUME_DESC} />,
      },
    };
  }
}
